// Layout.js
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import ThemeToggle from "./components/ThemeToggle";
import ScrollToTop from "./components/ScrollToTop";
import ProgressBar from "./components/ProgressBar";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Handle body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('body-no-scroll');
    } else {
      document.body.classList.remove('body-no-scroll');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('body-no-scroll');
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const handleNavClick = () => {
    closeMenu();
    // Ensure scroll to top when navigating
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Scroll to top on route change */}
      <ScrollToTopOnRouteChange />
      
      {/* Progress Bar */}
      <ProgressBar />
      
      {/* HEADER */}
      <header className="header">
        <div className="header-inner">
          {/* Logo */}
          <Link to="/" className="site-logo-wrap" onClick={handleNavClick}>
            <img src="/assets/logo1.png" alt="MYAC" className="site-logo" />
          </Link>

          {/* Navigation */}
          <nav className={`nav ${menuOpen ? "open" : ""}`}>
            <NavLink to="/" end onClick={handleNavClick}>
              Home
            </NavLink>
            <NavLink to="/services" onClick={handleNavClick}>
              Services
            </NavLink>
            <NavLink to="/work" onClick={handleNavClick}>
              Work
            </NavLink>
            <NavLink to="/about" onClick={handleNavClick}>
              About
            </NavLink>
            <Link
              to="/contact"
              className="btn btn-primary"
              onClick={handleNavClick}
            >
              Contact
            </Link>
          </nav>

          {/* Mobile Toggle */}
          <button
            className={`menu-toggle ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* Mobile Menu Backdrop */}
      <div 
        className={`menu-backdrop ${menuOpen ? "active" : ""}`}
        onClick={closeMenu}
      ></div>

      {/* PAGE CONTENT */}
      <main style={{ flexGrow: 1 }}>
        <Outlet />
      </main>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          {/* Brand */}
          <div>
            <div className="footer-brand">MYAC</div>
            <div className="footer-sub">Engineering · Cloud · AI</div>
          </div>

          {/* Footer Links */}
          <div className="footer-links">
            <div>
              <h4>Product</h4>
              <Link to="/services">Services</Link>
              <Link to="/work">Work</Link>
            </div>
            <div>
              <h4>Company</h4>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div>
              <h4>Resources</h4>
              <a href="#">Blog</a>
              <a href="#">Careers</a>
            </div>
          </div>

          {/* Social */}
          <div className="footer-social">
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-linkedin"></i></a>
            <a href="#"><i className="fab fa-github"></i></a>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} MYAC · All rights reserved
        </div>
      </footer>
      
      {/* Theme Toggle */}
      <ThemeToggle />
      
      {/* Scroll to Top */}
      <ScrollToTop />
    </div>
  );
}
